<template>
	<div class="XDLocalStorageIframe">
		<h1>Iframe...</h1>
	</div>
</template>

<script>
import { iframeURLRegex } from '@/app.config';
export default {
	name: 'XDLocalStorageIframe',

	data: () => ({
		MESSAGE_NAMESPACE: 'c2-cross-domain-local-message',
		IFRAME_URL_REGEX:  iframeURLRegex
	}),
	created() {
		window.addEventListener('message', this.receiveMessage, false)
		this.postData('iframe-ready')
	},
	methods: {
		receiveMessage(event) {
			const regex = new RegExp(this.IFRAME_URL_REGEX)

			if (!regex.test(event.origin)) {
				return
			}

			try {
				const data = JSON.parse(event.data)

				if (data && data.namespace === this.MESSAGE_NAMESPACE) {
					switch (data.action) {
						case 'get':
							this.getItem(data.id, data.key)
							break
						case 'set':
							this.setItem(data.id, data.key, data.value)
							break
						case 'remove':
							this.removeItem(data.id, data.key)
							break
						case 'clear':
							this.clear(data.id)
							break
					}
				}
			} catch (err) {
				// Not our message, ignore it
			}
		},
		postData(id, value = '') {
			parent.postMessage(JSON.stringify({
				id,
				namespace: this.MESSAGE_NAMESPACE,
				value,
			}), '*')
		},
		getItem(id, key) {
			const value = localStorage.getItem(key)
			this.postData(id, value)
		},
		setItem(id, key, value) {
			localStorage.setItem(key, value)
			this.postData(id)
		},
		removeItem(id, key) {
			localStorage.removeItem(key)
			this.postData(id)
		},
		clear(id) {
			localStorage.clear()
			this.postData(id)
		}
	},
}
</script>
